// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './plugin_conf'
import store from './store'
import './custom_conf'
// import axios from 'axios'

// import 'default-passive-events'
import 'babel-polyfill'
// import '../src/mock/index'
import './style/common.scss'
import Print from 'vue-print-nb'
// Vue.prototype.$languageDict = store.state.language.languageDict
Vue.config.productionTip = false
Vue.use(Print)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js